// @flow
import { useState, useCallback, useEffect } from 'react';

import { api } from 'app/api';
import { GET_REPORTS_DATA_FINANCES_BY_SELL_TYPE } from 'app/common/api/requests/reports/data';
import type { ReportsDataFinancesBySellTypeResult, SummaryData, SchoolData } from 'app/common/api/requests/reports/data.finances_by_sale_types';


export type { SummaryData, SchoolData };
export type ReportData = ReportsDataFinancesBySellTypeResult | null

export default function useReportData(reportId: ?number): [ReportData, boolean] {
  const [reportData, setReportData] = useState<ReportData>(null);
  const [loading, setLoading] = useState(false);

  const requestItems = useCallback(async () => {
    if (!reportId) return;

    setLoading(true);
    const res = await api.request(GET_REPORTS_DATA_FINANCES_BY_SELL_TYPE, {
      error: 'Не удалось загрузить данные отчета',
      params: {
        report_id: reportId,
      },
    });

    if (res) {
      setReportData(res);
    }
    setLoading(false);
  }, [reportId]);


  useEffect(() => {
    requestItems();
  }, [requestItems]);

  return [reportData, loading];
}
